import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../components/Layout';
import { PendingAssignmentPanel } from '../../components/PendingAssignmentPanel';
import { casesApi } from '../../services/cases';
import { documentsApi } from '../../services/documents';
import { Case } from '../../types';

/**
 * Page for viewing and managing documents pending case assignment.
 * 
 * Requirements: 2.3.1.1
 */
export const PendingDocumentsPage: React.FC = () => {
  const navigate = useNavigate();
  const [cases, setCases] = useState<Case[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCases();
  }, []);

  const loadCases = async () => {
    try {
      const result = await casesApi.list();
      setCases(result.cases);
    } catch (err) {
      console.error('Failed to load cases:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async (documentId: string, caseId: string) => {
    await documentsApi.assignDocument({ documentId, caseId });
  };

  const handleCreateCase = (documentId: string) => {
    // Navigate to case creation with document ID in state
    navigate('/cases/new', { state: { pendingDocumentId: documentId } });
  };

  return (
    <Layout>
      <div style={{ padding: '24px' }}>
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ margin: 0 }}>Pending Documents</h1>
          <p style={{ color: '#666', marginTop: '8px' }}>
            Documents that need to be assigned to a case
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '48px', color: '#666' }}>
            Loading...
          </div>
        ) : (
          <PendingAssignmentPanel
            cases={cases}
            onAssign={handleAssign}
            onCreateCase={handleCreateCase}
          />
        )}
      </div>
    </Layout>
  );
};

export default PendingDocumentsPage;
